import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, ClipboardList, FlaskConical, Key, PlugZap, Shield, Zap } from "lucide-react";

import { cn } from "../lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { TabsList, TabsTrigger } from "./ui/tabs";

const FLOW_ITEMS = [
  { id: "accounts", label: "Trading Accounts", icon: Key, href: "/settings?tab=accounts" },
  { id: "notifications", label: "Notifications", icon: Bell, href: "/settings?tab=notifications" },
  { id: "strategies", label: "Strategies", icon: Zap, href: "/settings?tab=strategies" },
  { id: "backtest", label: "Backtest", icon: FlaskConical, href: "/settings?tab=backtest" },
  { id: "risk", label: "Risk Settings", icon: Shield, href: "/settings?tab=risk" },
  { id: "trade-audit", label: "Trade Audit", icon: ClipboardList, href: "/settings?tab=trade-audit" },
  { id: "automation", label: "Automation", icon: PlugZap, href: "/settings?tab=automation" },
];

export default function SettingsFlowNav({ activeKey, onSelect }) {
  const navigate = useNavigate();
  const selectItem = (item) => {
    if (onSelect) {
      onSelect(item.id, item.href);
      return;
    }
    navigate(item.href);
  };

  return (
    <div className="mb-6">
      <div className="space-y-2 md:hidden">
        <label className="text-[11px] font-semibold uppercase tracking-[0.18em] text-zinc-500">
          Settings workspace
        </label>
        <Select
          value={activeKey}
          onValueChange={(value) => {
            const item = FLOW_ITEMS.find((candidate) => candidate.id === value);
            if (item) selectItem(item);
          }}
        >
          <SelectTrigger className="h-12 w-full border-white/10 bg-white/[0.05] text-white" aria-label="Settings workspace">
            <SelectValue placeholder="Choose a settings workspace" />
          </SelectTrigger>
          <SelectContent className="border-white/10 bg-zinc-950 text-white">
            {FLOW_ITEMS.map((item) => (
              <SelectItem key={item.id} value={item.id}>{item.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="hidden overflow-x-auto pb-1 md:block">
        <TabsList className="dashboard-surface-tabs min-w-max">
        {FLOW_ITEMS.map((item) => {
          const Icon = item.icon;

          return (
            <TabsTrigger
              key={item.id}
              value={item.id}
              aria-current={activeKey === item.id ? "page" : undefined}
              onClick={() => selectItem(item)}
              className={cn(
                "dashboard-surface-tab -ml-px inline-flex items-center justify-center whitespace-nowrap rounded-none px-4 py-2.5 text-sm font-medium transition-all first:ml-0 first:rounded-l-[10px] last:rounded-r-[10px] focus-visible:outline-none",
                "text-zinc-100 hover:text-white"
              )}
            >
              <Icon className="mr-2 h-4 w-4" />
              {item.label}
            </TabsTrigger>
          );
        })}
        </TabsList>
      </div>
    </div>
  );
}
